module.exports = __webpack_public_path__ + "static/img/1.0b029ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/1.png
// module id = ZEmy
// module chunks = 0